import { getEnv } from "../env";

export const isDevEnvironment = () => {
    return process.env.NODE_ENV === "development";
};

export const isNodeDevEnv = () => {
    return (getEnv().RUNNING_ON_NODE === "true" && getEnv().NODE_ENV === "development");
}

export const isDevEnv = () => {

    if(isNodeDevEnv())
        return true;
    
    if (window.location && window.location.host)
        return window.location.host.indexOf("localhost:") > -1;
    return false;
}

// New environment host scheme (mirrors the backend AppEnvironment): a non-prod deployment is
// reachable at <sub>-<slot>.engagebay.com where <slot> is dev / qa / staging (+ optional digits
// for parallel slots like qa1, dev2). The captured group is the ENV TIER (numbered slots collapse
// to their tier), so parallel qa slots all resolve to the same "qa" version of other services.
const ENV_HOST_RE = /-(dev|qa|staging)\d*\.engagebay\.com(?::\d+)?$/i;

export const isVersionEnv = () => {
    if (window.location && window.location.host) {
        const host = window.location.host;
        // New scheme (app-qa.engagebay.com) or legacy App Engine version host (…-dot-…appspot.com).
        return ENV_HOST_RE.test(host) || host.indexOf(".appspot.com") > -1;
    }
    return false;
}

export const isDevVersionEnv = () => {
    return (isVersionEnv() && getVersionId() == "dev")
}


export const isQAVersionEnv = () => {
    return (isVersionEnv() && (getVersionId() == "qa" || getVersionId() == "uiv2"))
}

export const isProductionEnv = () => {
    return !(isDevEnv() || isVersionEnv());
}

export const getVersionId = () => {
    if (!(window.location && window.location.host))
        return "";

    const host = window.location.host;

    // New scheme: env tier is the hostname suffix, e.g. app-qa.engagebay.com / app-qa1… -> "qa".
    const envMatch = host.match(ENV_HOST_RE);
    if (envMatch)
        return envMatch[1].toLowerCase();

    // Legacy App Engine scheme: <sub>-dot-<version>-dot-<app>.appspot.com
    if (host.indexOf(".appspot.com") > -1) {
        const match = host.match(/-dot-(.*?)?-dot-/);
        return match ? (match[1] || "") : "";
    }

    return "";
}